document.addEventListener('DOMContentLoaded', function() {
  const swiperContainers = document.querySelectorAll('.new-testimonials-swiper');
  
  swiperContainers.forEach((swiperEl) => {
    const section = swiperEl.closest('[data-section-type="new-testimonials-slider"]');
    if (!section) return;
    
    const sectionId = section.getAttribute('data-section-id');
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    
    // Get settings from section attributes or use defaults
    const autoplay = section.dataset.autoplay !== 'false';
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed) || 5;
    const showArrows = section.dataset.showArrows !== 'false';
    const showDots = section.dataset.showDots !== 'false';
    
    // Initialize Swiper
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: slideCount > 1,
      
      // Autoplay
      autoplay: autoplay && slideCount > 1 ? {
        delay: autoplaySpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      
      // Navigation
      navigation: showArrows ? {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev'),
      } : false,
      
      // Pagination
      pagination: showDots ? {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      
      // Responsive breakpoints
      breakpoints: {
        // Mobile
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // Tablet
        768: {
          slidesPerView: slideCount >= 2 ? 2 : 1,
          spaceBetween: 30,
        },
        // Desktop
        1024: {
          slidesPerView: slideCount >= 3 ? 3 : slideCount,
          spaceBetween: 30,
        }
      },
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      
      // Mouse wheel
      mousewheel: {
        forceToAxis: true,
      },
    });
    
    // Store swiper instance for potential future use
    swiperEl.swiper = swiper;
  });
});

// Handle Shopify theme editor events
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target;
    const swiperEl = section.querySelector('.new-testimonials-swiper');
    
    if (swiperEl && !swiperEl.swiper) {
      // Reinitialize swiper when section is loaded in theme editor
      setTimeout(() => {
        const event = new Event('DOMContentLoaded');
        document.dispatchEvent(event);
      }, 100);
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    const section = event.target;
    const swiperEl = section.querySelector('.new-testimonials-swiper');
    
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  });
  
  document.addEventListener('shopify:block:select', function(event) {
    const block = event.target;
    const swiperEl = block.closest('.new-testimonials-swiper');
    
    if (swiperEl && swiperEl.swiper) {
      const slideIndex = Array.from(block.parentNode.children).indexOf(block);
      swiperEl.swiper.slideTo(slideIndex);
    }
  });
}
